import Link from "next/link"; // ✅ Import Next.js Link for Client-side Navigation

/**
 * 📌 Breadcrumb Component
 * This component dynamically generates a breadcrumb navigation trail.
 * 
 * @param {Array} path - An array of breadcrumb items (e.g., ["Causes", "Education"])
 * @returns {JSX.Element} - A dynamic breadcrumb navigation
 */
const Breadcrumb = ({ path = [] }) => (
  <nav className="container mx-auto py-4 px-6 text-gray-600 text-sm">
    
    {/* ✅ Always Show Home Link as the First Item */}
    <Link href="/" className="hover:underline">Home</Link>

    {/* ✅ Dynamically Map Over Breadcrumb Items */}
    {path.map((item, index) => (
      <span key={index}>
        {/* ✅ Separator Icon (›) Between Links */}
        <span className="mx-2">›</span>

        {/* ✅ Last Item is Not Clickable (Bold) */}
        {index === path.length - 1 ? (
          <span className="text-gray-800 font-semibold">{item}</span>
        ) : (
          /* ✅ Create Clickable Links for Other Items */
          <Link href={`/${item.toLowerCase().replace(/\s+/g, "-")}`} className="hover:underline">
            {item}
          </Link>
        )}
      </span>
    ))}
  </nav>
);

export default Breadcrumb;